import { Stack, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CustomChip } from 'src/shared/components/organisms/customChip';
import { MemberUpdateTypeEnum } from 'src/shared/models/enums/memberUpdateType.enum';

type MemberUpdateStatusesProps = {
  status: MemberUpdateTypeEnum;
  chipSize: 'small' | 'medium' | undefined;
};

export const MemberUpdateStatuses = (props: MemberUpdateStatusesProps) => {
  const { status, chipSize } = props;
  const { t } = useTranslation(['member']);
  if (!status) return <></>;

  return (
    <Stack direction='row' spacing={1} sx={{ '& .MuiChip-filled ': { borderRadius: 1 } }}>
      {status === MemberUpdateTypeEnum.Update && (
        <Tooltip describeChild title={`${t('member:memberUpdateTypeEnum.Update')}`} arrow>
          <CustomChip label={t('member:memberUpdateTypeEnum.Update')} color='warning' size={chipSize} />
        </Tooltip>
      )}
      {status === MemberUpdateTypeEnum.NewMember && (
        <Tooltip describeChild title={`${t('member:memberUpdateTypeEnum.NewMember')}`} arrow>
          <CustomChip label={t('member:memberUpdateTypeEnum.NewMember')} color='info' size={chipSize} />
        </Tooltip>
      )}
    </Stack>
  );
};
